module.exports = __webpack_public_path__ + "fonts/iconfont.0338b57c.woff2";